export default {
	sex: [
		{
			label: 'Male',
			value: '12'
		},
		{
			label: 'Female',
			value: '13'
		},
	],
	race: [
		{
			label: 'American Indian or Alaskan Native',
			value: '15',
		},
		{
			label: 'Asian or Pacific Islander',
			value: '16',
		},
		{
			label: 'Black',
			value: '17',
		},
		{
			label: 'Unknown',
			value: '19',
		},
		{
			label: 'White',
			value: '18',
		},
	],
	pAndPDistrictOffices: [
		{
			label: 'Abingdon',
			value: 'Abingdon',
		},
		{
			label: 'Accomac',
			value: 'Accomac',
		},
		{
			label: 'Alexandria',
			value: 'Alexandria',
		},
		{
			label: 'Arlington',
			value: 'Arlington',
		},
		{
			label: 'Ashland',
			value: 'Ashland',
		},
		{
			label: 'Bedford',
			value: 'Bedford',
		},
		{
			label: 'Charlottesville',
			value: 'Charlottesville',
		},
		{
			label: 'Chesapeake',
			value: 'Chesapeake',
		},
		{
			label: 'Chesterfield',
			value: 'Chesterfield',
		},
		{
			label: 'Culpeper',
			value: 'Culpeper',
		},
		{
			label: 'Danville',
			value: 'Danville',
		},
		{
			label: 'Emporia',
			value: 'Emporia',
		},
		{
			label: 'Fairfax',
			value: 'Fairfax',
		},
		{
			label: 'Farmville',
			value: 'Farmville',
		},
		{
			label: 'Fincastle',
			value: 'Fincastle',
		},
		{
			label: 'Franklin',
			value: 'Franklin',
		},
		{
			label: 'Fredricksburg',
			value: 'Fredricksburg',
		},
		{
			label: 'Gloucester',
			value: 'Gloucester',
		},
		{
			label: 'Hampton',
			value: 'Hampton',
		},
		{
			label: 'Harrisonburg',
			value: 'Harrisonburg',
		},
		{
			label: 'Henrico',
			value: 'Henrico',
		},
		{
			label: 'Leesburg',
			value: 'Leesburg',
		},
		{
			label: 'Lynchburg',
			value: 'Lynchburg',
		},
		{
			label: 'Manassas',
			value: 'Manassas',
		},
		{
			label: 'Martinsville',
			value: 'Martinsville',
		},
		{
			label: 'Newport News',
			value: 'Newport News',
		},
		{
			label: 'Norfolk',
			value: 'Norfolk',
		},
		{
			label: 'Norton',
			value: 'Norton',
		},
		{
			label: 'Petersburg',
			value: 'Petersburg',
		},
		{
			label: 'Portsmouth',
			value: 'Portsmouth',
		},
		{
			label: 'Radford',
			value: 'Radford',
		},
		{
			label: 'Richmond',
			value: 'Richmond',
		},
		{
			label: 'Roanoke',
			value: 'Roanoke',
		},
		{
			label: 'Rocky Mount',
			value: 'Rocky Mount',
		},
		{
			label: 'South Boston',
			value: 'South Boston',
		},
		{
			label: 'Staunton',
			value: 'Staunton',
		},
		{
			label: 'Suffolk',
			value: 'Suffolk',
		},
		{
			label: 'Tazwell',
			value: 'Tazwell',
		},
		{
			label: 'Virginia Beach',
			value: 'Virginia Beach',
		},
		{
			label: 'Warsaw',
			value: 'Warsaw',
		},
		{
			label: 'Williamsburg',
			value: 'Williamsburg',
		},
		{
			label: 'Winchester',
			value: 'Winchester',
		},
		{
			label: 'Wytheville',
			value: 'Wytheville',
		},
	],
	relationshipTypes: [
		{
			label: 'Father',
			value: '6',
			data: 'immediate',
		},
		{
			label: 'Mother',
			value: '14',
			data: 'immediate',
		},
		{
			label: 'Father-in-law',
			value: '300',
			data: 'non-immediate',
		},
		{
			label: 'Mother-in-law',
			value: '301',
			data: 'non-immediate',
		},
		{
			label: 'Stepfather',
			value: '400',
			data: 'immediate',
		},
		{
			label: 'Stepmother',
			value: '401',
			data: 'immediate',
		},
		{
			label: 'Brother',
			value: '3',
			data: 'immediate',
		},
		{
			label: 'Sister',
			value: '12',
			data: 'immediate',
		},
		{
			label: 'Stepbrother',
			value: '402',
			data: 'immediate',
		},
		{
			label: 'Stepsister',
			value: '403',
			data: 'immediate',
		},
		{
			label: 'Brother-in-law',
			value: '302',
			data: 'non-immediate',
		},
		{
			label: 'Sister-in-law',
			value: '303',
			data: 'non-immediate',
		},
		{
			label: 'Lawful Spouse',
			value: '9',
			data: 'immediate',
		},
		{
			label: 'Grandfather',
			value: '7',
			data: 'immediate',
		},
		{
			label: 'Grandmother',
			value: '8',
			data: 'immediate',
		},
		{
			label: 'Son',
			value: '13',
			data: 'immediate',
		},
		{
			label: 'Daughter',
			value: '11',
			data: 'immediate',
		},
		{
			label: 'Aunt',
			value: '1',
			data: 'non-immediate',
		},
		{
			label: 'Uncle',
			value: '16',
			data: 'non-immediate',
		},
		{
			label: 'Nephew',
			value: '21',
			data: 'non-immediate',
		},
		{
			label: 'Niece',
			value: '20',
			data: 'non-immediate',
		},
		{
			label: 'Cousin',
			value: '10',
			data: 'non-immediate',
		},
		{
			label: 'Friend',
			value: '0',
			data: 'non-immediate',
		},
	],
}


// WEBPACK FOOTER //
// ./src/utils/selectFieldOptions.js